import React from 'react'
import {InteractiveIcon as Icon} from '@components/common/interactive-icon/interactive-icon'
import {cn} from '@containers/html-utils'
import ToFullscreenIcon from './to-fullscreen.svg'
import FromFullscreenIcon from './from-fullscreen.svg'
import HistoryIcon from './history.svg'
import {useTaskDescription} from '../task-description-store'
import {observer} from 'mobx-react-lite'

export const TopPanelIcons = observer(() => {
  const [state, store] = useTaskDescription()

  const onHistoryModeOn = () => {
    void store.saveContent()
    store.setHistoryMode(true)
  }

  const fullscreenIconCls = cn(!state.fullscreen && 'ml-auto')

  return (
    <>
      <Icon className={fullscreenIconCls} onClick={onHistoryModeOn}>
        <HistoryIcon />
      </Icon>
      <Icon onClick={store.fullscreenToggle}>
        {state.fullscreen ? <FromFullscreenIcon /> : <ToFullscreenIcon />}
      </Icon>
    </>
  )
})
